import React, { useState } from "react";
import { DatePicker, Select, Table } from "antd";
import {
  useGetManHourReportQuery,
  useGetProjectCostingReportQuery,
  
} from "AppQuries/report/project-report";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import ReportTools from "Components/UI/ReportTools";
import { useTableSearch } from "core/Operations/useTableSearch";
import { loggedInUser } from "core/redux/slice/authSlice";
import { format, toDate } from "date-fns";
import Error404 from "MainPages/ErrorPages/error404";

import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "Router/all_routes";
import { ArrowLeft } from "react-feather";
import { Link } from "react-router-dom";
import { SearchIcon } from "Components/UI/SearchIcon";
import { useFormattedEmployees } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import { useFormattedProjectOption } from "core/Operations/formattedOption/useFormattedMasterOptions";
import { BackIcon } from "Components/UI/Icon/Icons";
const { RangePicker } = DatePicker;
const ProjectCostingReport = () => {
  const userData = useSelector(loggedInUser);
  const [queryParams, setQueryParams] = useState({
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),

    employeeCode: 0,
    projectCode: "",
  });

  const {
    data: reportData,
    isLoading,
    isFetched,
    isError,
    error,
    refetch,
  } = useGetProjectCostingReportQuery({
    ...queryParams,
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    userCode: userData?.userName,
    userId: userData?.userID,
    isAllCompanies: userData?.isAllCompanies,
    selectedCompanyCode: userData?.selectedCompanyCode,
  });

  const empOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: 0,
  });

  const projectOptions = useFormattedProjectOption({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const columns = [
    {
      title: "Project Name",
      dataIndex: "projectName",
    },
    {
      title: "Total Basic Salary",
      dataIndex: "totalBasicSalary",
    },
    {
      title: "Total OT Amount",
      dataIndex: "otTotalAmount",
    },

    {
      title: "Total Allowance",
      dataIndex: "allowanceTotal",
    },
    {
      title: "Total Employee CPF",
      dataIndex: "totalEmployeeCPF",
    },
     {
      title: "Total SDL",
      dataIndex: "totalSDL",
    },
    {
      title: "Total Levy",
      dataIndex: "totalLevy",
    },
    {
      title: "Total Costing",
      dataIndex: "totalCosting",
    },
  ];
  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    reportData,
    searchColumns,
  );

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };
  if (isLoading || !isFetched) return <LoadingSpinner />;

  if (isError) return <Error404 error={error} />;

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Project Costing Report</h4>
              {/* <h6>Generate man hour project report</h6> */}
            </div>
          </div>
          <ReportTools
            columns={columns}
            data={filteredData}
            fileName={`Project Costing Report (${queryParams.fromDate} - ${queryParams.toDate})`}
            pdfTheme="striped"
            refresh={refetch}
            isPdf={true}
          />
          <div className="page-btn">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
            >
              <Link to={all_routes.report_list} className="btn btn-secondary">
                <BackIcon className="me-2" />
                Back
              </Link>
            </OverlayTrigger>
          </div>
        </div>

        <div className="card border-0">
          <div className="card-body table-list-card">
            <div className="form-row row">
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <div className="form-group">
                  <label className="form-label">Start Date – End Date</label>
                  <RangePicker
                    className="form-control"
                    style={{ display: "flex" }}
                    onChange={(date, dateFormat) => {
                      if (date) {
                        updateQueryParams("fromDate", dateFormat[0]);
                        updateQueryParams("toDate", dateFormat[1]);
                      }
                    }}
                    defaultValue={[
                      dayjs(queryParams.fromDate, "YYYY-MM-DD"),
                      dayjs(queryParams.toDate, "YYYY-MM-DD"),
                    ]}
                    dateFormat="YYYY-MM-DD"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    // disabledDate={(current) => {
                    //   return current && current > dayjs().startOf("day");
                    // }}
                  />
                </div>
              </div>

              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <div className="form-group">
                  <label className="form-label">Employee</label>
                  <Select
                    value={
                      queryParams?.employeeCode ? queryParams?.employeeCode : ""
                    }
                    options={empOptions}
                    allowClear={true}
                    onSelect={(selectedOption) => {
                      updateQueryParams("employeeCode", selectedOption);
                    }}
                    onClear={() => {
                      updateQueryParams("employeeCode", 0);
                    }}
                    className="form-control"
                    variant="borderless"
                    showSearch={true}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </div>
              </div>

              {/* <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <div className="form-group">
                  <label className="form-label">Project</label>
                  <Select
                    value={queryParams.projectCode}
                    options={projectOptions}
                    allowClear={true}
                    onSelect={(selectedOption) => {
                      updateQueryParams("projectCode", selectedOption);
                    }}
                    onClear={() => {
                      updateQueryParams("projectCode", "");
                    }}
                    className="form-control"
                    variant="borderless"
                    showSearch={true}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </div>
              </div> */}
              <div className="col-lg-2 col-sm-2 col-2">
                <div className="input-blocks">
                  <label className="form-label">&nbsp;</label>
                  <Link
                    type="button"
                    className="btn btn-filters ms-auto"
                    onClick={refetch}
                  >
                    <SearchIcon />
                    Search
                  </Link>
                </div>
              </div>
            </div>

            <div className="row">
              <div className={`table-responsive`}>
                <Table
                  columns={columns}
                  dataSource={filteredData}
                  rowKey={(record, index) => index}
                  pagination={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCostingReport;
